import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const CircleInfoIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M14.1663 8.00034C14.1663 4.59469 11.4059 1.83352 8.00033 1.83334C4.59457 1.83334 1.83334 4.59458 1.83334 8.00034C1.83351 11.4059 4.59468 14.1664 8.00033 14.1664C11.4058 14.1662 14.1662 11.4058 14.1663 8.00034ZM15.1663 8.00034C15.1662 11.9581 11.9581 15.1662 8.00033 15.1664C4.0424 15.1664 0.833512 11.9582 0.833336 8.00034C0.833336 4.04229 4.04229 0.833344 8.00033 0.833344C11.9582 0.833519 15.1663 4.0424 15.1663 8.00034Z"
      fill="currentColor"
    />
    <path
      d="M7.5 10.667V8C7.5 7.72386 7.72386 7.5 8 7.5C8.27614 7.5 8.5 7.72386 8.5 8V10.667C8.49982 10.943 8.27603 11.167 8 11.167C7.72397 11.167 7.50018 10.943 7.5 10.667Z"
      fill="currentColor"
    />
    <path
      d="M8.00684 4.83334C8.2829 4.83343 8.50684 5.05726 8.50684 5.33334C8.50684 5.60943 8.2829 5.83325 8.00684 5.83334H8C7.72386 5.83334 7.5 5.60949 7.5 5.33334C7.5 5.0572 7.72386 4.83334 8 4.83334H8.00684Z"
      fill="currentColor"
    />
  </svg>
);
